import FaqEdit from "components/Cards/FaqEdit";
import React from "react";


export default function EditTeam() {
  return (
    <>
      <div className="flex flex-wrap mt-4">
        <div className="w-full mb-12 px-4">
          <FaqEdit />
        </div>
      </div>
    </>
  );
}
